<template>
  <div class="card v3-card">
    <!-- Header -->
    <div class="v3-header">
      <div class="v3-header-top">
        <div class="v3-title-section">
          <h3 class="v3-title">{{statSubtitle}}</h3>
          <p class="v3-subtitle">Overview of Performance</p>
        </div>
        <div class="v3-date-select" v-if="filter">
          <select :name="action" @change="ChangeDateCallcenter($event)" v-model="timeserchtype" class="v3-select">
            <option value="Today">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="thisweek">This week</option>
            <option value="lastweek">Last week</option>
            <option value="This Month">This Month</option>
            <option value="Last Month">Last Month</option>
            <option value="This Year">This Year</option>
            <option value="betweendate">Between date</option>
          </select>
        </div>
      </div>

      <!-- Filters -->
      <div v-if="filterseller && currentUser && currentUser.type && currentUser.role && currentUser.role.name" class="v3-filters">
        <div class="v3-filter-row">
          <div class="v3-filter-item" v-if="currentUser.role.name!='Seller' && currentUser.type!='Seller'">
            <v-select
              @search="getUsersDebance($event,'shipsen')"
              @input="CheckSellerProducts($event,action,'seller')"
              label="fullName"
              placeholder="Seller"
              :options="sellers"
              v-model="sellerdata"
              class="v3-filter-select"
            ></v-select>
          </div>
          <div class="v3-filter-item">
            <v-select
              @search="getProducts($event,'shipsen')"
              @input="CheckSellerProducts($event,action,'product')"
              label="name"
              placeholder="Product"
              :options="products"
              v-model="productdata"
              class="v3-filter-select"
            ></v-select>
          </div>
          <button class="v3-filter-clear" @click="removedata(action)">
            <i class="material-icons" style="font-size:16px">close</i>
          </button>
        </div>
        <div v-if="filter && timeserchtype=='betweendate'" class="v3-filter-date">
          <date-picker placeholder="Range date ..." format="YYYY-MM-DD" type="date" class="v3-datepicker" v-model="fromDate" range></date-picker>
          <button @click="FindRecordsBetweenDate()" :class="!fromDate?'noselect':''" :disabled="!fromDate" class="v3-filter-search">
            <i class="material-icons" style="font-size:18px">search</i>
          </button>
        </div>
      </div>
    </div>

    <!-- Chart -->
    <div class="v3-body">
      <loading :active.sync="loading" :is-full-page="fullPage"></loading>
      <div :id="id"></div>
    </div>

    <!-- Summary cards -->
    <div class="v3-summary" v-if="dataChart && dataChart[0]">
      <div class="v3-summary-card">
        <span class="v3-summary-value v3-confirmed">{{ totalConfirmed }}</span>
        <span class="v3-summary-label">CONFIRMED</span>
      </div>
      <div class="v3-summary-card">
        <span class="v3-summary-value v3-cancelled">{{ totalCancelled }}</span>
        <span class="v3-summary-label">CANCELLED</span>
      </div>
      <div class="v3-summary-card">
        <span class="v3-summary-value">{{ totalAll }}</span>
        <span class="v3-summary-label">TOTAL</span>
      </div>
      <div class="v3-summary-card">
        <span class="v3-summary-value v3-rate">{{ confirmRate }}%</span>
        <span class="v3-summary-label">CONFIRM RATE</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "card-stats-v3",
  props: {
   loading:{required:false},
   statSubtitle: {default: "Traffic",},
   filter: {default: false,},
   id:{type:String},
   from:{},
   to:{},
   dataChart:{type:Array},
   label:{type:Array},
   timeserch:{},
   action: {},
   seller:{},
   product:{},
   sellers:{type:Array},
   products:{type:Array},
   currentUser:{type:Object},
    filterseller: {
      default: false,
    },
  },
  computed: {
    totalConfirmed() {
      return this.dataChart && this.dataChart[0] ? this.dataChart[0].reduce((a, b) => a + b, 0) : 0;
    },
    totalCancelled() {
      return this.dataChart && this.dataChart[1] ? this.dataChart[1].reduce((a, b) => a + b, 0) : 0;
    },
    totalAll() {
      return this.totalConfirmed + this.totalCancelled;
    },
    confirmRate() {
      return this.totalAll ? Math.round((this.totalConfirmed * 100) / this.totalAll) : 0;
    },
  },
  data() {
    return {
      fullPage: false,
      myChart: "",
      timeserchtype:this.timeserch,
      fromDate:this.from,
      toDate:this.to,
      sellerdata:this.seller,
      productdata:this.product,
    };
  },
 watch: {
   'timeserch': function () {
      this.timeserchtype=this.timeserch;
   },
   'seller': function () {
     console.log('seller------',this.seller)
      this.sellerdata=this.seller;
   },
   'product': function () {
     console.log('product------',this.product)
      this.productdata=this.product;
   },
    dataChart: function () {
      if (this.myChart != null) this.myChart.destroy();
      this.drawChart(this.dataChart,this.label);
      this.myChart.render();
    },
  },
  async mounted(){
     await this.drawChart(this.dataChart,this.label);
     if (this.myChart) this.myChart.render();
      if(this.currentUser && this.currentUser.role && this.currentUser.role.name=='Seller' && this.currentUser.type=='Seller') this.sellerdata=this.currentUser;
  },
   methods: {
     ChangeDateCallcenter: function (val) {
         this.$emit("ChangeDateCallcenter", val);
    },
    FindRecordsBetweenDate: function (val) {
         this.$emit("FindRecordsBetweenDate", this.action,this.fromDate,this.toDate);
    },
      FindRecordsSellers: function (val) {
        this.$emit("FindRecordsSellers", this.action,this.sellerdata,this.productdata);
    },
    getUsersDebance: function (name) {
        this.$emit("getUsersDebance", name);
     }, 
    getProducts: function (name) {
        this.$emit("getProducts", name);
     }, 
    async CheckSellerProducts(seller,action,model){
       this.$emit("CheckSellerProducts", seller,action,model);
    },
    removedata: function (val) {
        this.$emit("removedata", this.action);
     }, 
    drawChart(chartData,label) {
       var ctx = document.getElementById(this.id);
        this.myChart = new ApexCharts(ctx, {
		chart: {
			type: 'bar',
      height: 390,
      stacked: true,
			toolbar: {
				show: false
			},
      fontFamily: 'inherit',
		},
    plotOptions: {
      bar: {
        columnWidth: '45%',
        borderRadius: 6,
      }
    },
		stroke: {
			width: 0,
			curve: 'smooth'
		},
    legend: {
      position: 'bottom',
      fontSize: '13px',
      fontWeight: 500,
      labels: { colors: '#64748b' },
      markers: { radius: 4, width: 10, height: 10 },
      formatter: function(label, opts) {
        return label + " (" + opts.w.globals.series[opts.seriesIndex].reduce((a, b) => {return a + b;}, 0)+")";
      }
    },
		dataLabels: {
			enabled: false
		},
		series: [{
			name: 'Confirmed',
			data: chartData[0]
		}, {
			name: 'Cancelled',
			data: chartData[1]
		}],
		fill: {
			type: 'solid',
			opacity: 1,
		},
		colors: ['#4285f4', '#fa896b'],
		labels: label,
    grid: {
      borderColor: '#f1f5f9',
      strokeDashArray: 4,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },
    xaxis: {
      labels: {
        style: { colors: '#94a3b8', fontSize: '12px' }
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        style: { colors: '#94a3b8', fontSize: '12px' }
      }
    },
		markers: {
			size: 0
		},
		tooltip: {
			enabled: true,
      shared: true,
      intersect: false,
			theme: 'light',
      x: {show: true},
      style: { fontSize: '12px' },
		}
	});
    },
   }
};
</script>
<style scoped>
/* V3 Card */
.v3-card {
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  background: #ffffff;
  overflow: hidden;
  transition: all 0.3s ease;
}
.v3-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* Header */
.v3-header {
  padding: 20px 24px 12px;
}
.v3-header-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}
.v3-title {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  line-height: 1.3;
}
.v3-subtitle {
  font-size: 13px;
  color: #94a3b8;
  margin: 2px 0 0;
  font-weight: 400;
}

/* Date select */
.v3-select {
  appearance: auto;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 8px 14px;
  cursor: pointer;
  outline: none;
  min-width: 130px;
  transition: border-color 0.2s;
}
.v3-select:hover {
  border-color: #cbd5e1;
}
.v3-select:focus {
  border-color: #4285f4;
}

/* Filters */
.v3-filters {
  background: #f8fafc;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 4px;
}
.v3-filter-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.v3-filter-item {
  flex: 1;
  min-width: 0;
}
.v3-filter-select {
  font-size: 12px !important;
  background: #ffffff;
  border-radius: 8px;
}
.v3-filter-clear {
  width: 32px;
  height: 32px;
  min-width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  background: #fee2e2;
  color: #ef4444;
  cursor: pointer;
  transition: all 0.2s;
}
.v3-filter-clear:hover {
  background: #fecaca;
}
.v3-filter-date {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}
.v3-datepicker {
  flex: 1;
}
.v3-filter-search {
  width: 34px;
  height: 34px;
  min-width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  background: #4285f4;
  color: #ffffff;
  cursor: pointer;
}
.v3-filter-search:hover {
  background: #3367d6;
}
.v3-filter-search.noselect {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Body */
.v3-body {
  padding: 0 16px 16px;
  position: relative;
  min-height: 200px;
}

/* Summary cards */
.v3-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 0 16px 14px;
}
.v3-summary-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 6px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fafbfc;
  transition: all 0.2s;
}
.v3-summary-card:hover {
  border-color: #cbd5e1;
  background: #f1f5f9;
}
.v3-summary-value {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}
.v3-summary-value.v3-confirmed {
  color: #4285f4;
}
.v3-summary-value.v3-cancelled {
  color: #ef4444;
}
.v3-summary-value.v3-rate {
  color: #13deb9;
}
.v3-summary-label {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 4px;
}

@media (max-width: 640px) {
  .v3-summary {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
